import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import FormWrapper from '@client/components/formComponents/formWrapper/FormWrapper';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import { valueOrEmptyStr } from '@client/shared/utils/utils/utils';
import InputGroup from '@client/components/formComponents/inputGroup/InputGroup';
import TextareaGroup from '@client/components/formComponents/textareaGroup/TextareaGroup';
import RecaptchaConditions from '@client/components/recaptchaConditions/RecaptchaConditions';
import { postAndHandleFundraiserComment } from '@client/redux/fundraiser/fundraiserActions';
import { NotificationContext } from '@client/components/notificationProvider/NotificationProvider';
import { selectUserInfo } from '@client/redux/user/userReducer';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import styles from './guestbookForm.scss';

class GuestbookForm extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isDisabledSubmit: false,
    };
  }

  static contextType = NotificationContext;

  renderForm = (formProps) => {
    const { values, errors } = formProps;
    const { guestbookFormTitle, publishButtonLabel } = this.props.translations;

    return (
      <form onSubmit={formProps.handleSubmit}>
        <h3 className={styleHelper.titleMdPrimary}>
          {guestbookFormTitle && guestbookFormTitle}
        </h3>

        <div>
          <div className={styleHelper.formRow}>
            <InputGroup
              labelText={'Namn*'}
              name={'authorName'}
              value={valueOrEmptyStr(values.authorName)}
              onChange={formProps.handleChange}
              onBlur={formProps.handleBlur}
              errorLabel={errors.authorName}
            />
            <InputGroup
              labelText={'Rubrik*'}
              name={'title'}
              value={valueOrEmptyStr(values.title)}
              onChange={formProps.handleChange}
              onBlur={formProps.handleBlur}
              errorLabel={errors.title}
              maxLength={50}
            />
          </div>
          <div className={styleHelper.formRow}>
            <TextareaGroup
              className={styleHelper.displayFlexOne}
              labelText={'Meddelande*'}
              name={'content'}
              rows={4}
              maxlength={750}
              value={valueOrEmptyStr(values.content)}
              onChange={formProps.handleChange}
              onBlur={formProps.handleBlur}
              errorLabel={errors.content}
            />
          </div>
        </div>
        <div className={styles.recaptchaTerms}>
          <RecaptchaConditions />
        </div>
        <div className={styles.submitBtnContainer}>
          <button className={styleHelper.btnPrimaryMd} type={'submit'}>
            {publishButtonLabel && publishButtonLabel}
          </button>
        </div>
      </form>
    );
  };

  handleSubmit = (values, { resetForm }) => {
    const { dispatch, fundraiserSlug } = this.props;
    this.setDisabledSubmit(true);

    dispatch(postAndHandleFundraiserComment(fundraiserSlug, values))
      .then((response) => {
        if (response.payload.status !== 200) {
          this.context.displayNotification(
            'ERROR',
            'Din kommentar kunde inte publiceras. Försök igen.'
          );
          return;
        }
        resetForm();
        this.context.displayNotification(
          'SUCCESS',
          'Tack! Din kommentar har publicerats.'
        );
      })
      .catch(() => {
        this.context.displayNotification(
          'ERROR',
          'Din kommentar kunde inte publiceras. Försök igen.'
        );
      });
  };

  setDisabledSubmit = (disabled) => {
    this.setState((state) => {
      return { ...state, isDisabledSubmit: disabled };
    });
  };

  render() {
    const { className, loggedInUser } = this.props;

    return (
      <div className={classNames(styles.guestbookForm, className)}>
        <FormWrapper
          initialValues={{
            authorName: getIn(loggedInUser, 'name') || '',
            title: '',
            content: '',
          }}
          onSubmit={this.handleSubmit}
          component={this.renderForm}
          validateOnBlur={false}
          validateOnChange={false}
        />
      </div>
    );
  }
}

GuestbookForm.propTypes = {
  className: PropTypes.string,
  entry: PropTypes.object,
  fundraiserSlug: PropTypes.string,
  translations: PropTypes.objectOf(PropTypes.string),
  dispatch: PropTypes.func,
  loggedInUser: ImmutablePropTypes.map,
};

function mapStateToProps(state) {
  return {
    loggedInUser: selectUserInfo(state),
  };
}

export default connect(mapStateToProps)(GuestbookForm);
